export default __webpack_public_path__ + "static/media/mail.c3984485.svg";